import styled from 'styled-components';

const StyledContainer = styled.div`
	position: absolute;
	display: grid;
	grid-template-columns: 440px 1fr;
	width: calc(100% - 80px);
	height: calc(100% - 80px);
	user-select: none;
	margin: 40px;
	background-color: rgba(17, 19, 20, 0.85);
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 10px;
	overflow: hidden;
`;

const StyledRightContainer = styled.div`
	display: flex;
	flex-direction: column;
	padding: 40px;
`;

const StyledMainContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 40px;
	height: 100%;
`;

const StyledPanelControlsContainer = styled.div`
	display: flex;
	justify-content: flex-end;
`;

export {
	StyledContainer,
	StyledMainContainer,
	StyledPanelControlsContainer,
	StyledRightContainer,
};
